import { Environment } from "./environment.type";

export const environment: Environment = {
  production: false,
  apiUrl: "https://obs.bonatti.it", // "http://localhost:4000",//
  maxFileUpload: 3
};